import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/10_dark_green/10_dark_green"
 * Contains 1 texture(s)
 */
export class Mobile10DarkGreenAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/10_dark_green/10_dark_green';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '10_dark_green.png'
    ] as const;
}
